export interface Tag {
    id: string;
    name: string;
}

export class TagModel {
    id: string;
    name: string;

    constructor(model: Tag) {
        this.id = model.id;
        this.name = model.name;
    }
}
